export default __webpack_public_path__ + "static/mongodb-88af2d1980770fc2a982c5dc2adcae01.svg";